<!-- 考试数据中心详细页 -->

<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="830px"
      height="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>考试报告</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row" type="flex" justify="end">
            <div class="option">
              <el-button @click="handleCancel" plain>
                <span>返回列表</span>
              </el-button>
              <el-button plain type="primary" @click="downloadReport">
                <span>下载报告</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all" ref="pdf">
            <!-- 表单区域-->
            <el-row class="title-row" type="flex" justify="center">
              <span class="title">{{title}}</span>
            </el-row>
            <div class="switch-content">
              <el-form size="small">
                <div class="formtable">
                  <div v-for="(item,index) in DataList" :key="item.id">
                    <el-row
                      :gutter="20"
                      class="row-bg"
                      v-if="item.type == 1 || item.type == 0"
                    >
                      <el-col :span="20">
                        <div class="grid-content bg-purple">
                          <el-form-item>
                            {{
                              "第" + (index+1) + "题：" + item.questionsList.replace(/\n/g,'')
                            }}
                            <span class="topictype" v-if="item.type == 0">[单选题]</span>
                            <span class="topictype" v-else>[多选题]</span>
                          </el-form-item>
                          <el-form-item label="">
                            <vxe-table
                              :data="item.options"
                              round
                              border
                              class="mytable-scrollbar"
                              style="width: 100%"
                              ref="multipleTable"
                              empty-text="没有更多数据了！"
                              resizable
                              stripe
                            >
                              <template
                                v-for="(item, key) in Data1List"
                                :key="key"
                              >
                                <vxe-table-column
                                  v-if="item.isShow && item.prop=='ratio'"
                                  :field="item.prop"
                                  :title="item.label"
                                  :width="item.width"
                                  align="center"
                                  :class-name="JSON.stringify(item)"
                                  :formatter="formatterData"
                                >
                                  <template #default="{ row, column }">
                                    <el-progress :percentage="row[column.property]" :color="customColorMethod"></el-progress>
                                  </template>
                                </vxe-table-column>
                                <vxe-table-column
                                  v-if="item.isShow && item.prop!='ratio'"
                                  :field="item.prop"
                                  :title="item.label"
                                  :width="item.width"
                                  align="center"
                                  :class-name="JSON.stringify(item)"
                                  :formatter="formatterData"
                                />
                              </template>
                            </vxe-table>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>

                    <el-row
                      :gutter="20"
                      class="row-bg"
                      v-if="item.type == 2"
                    >
                      <el-col :span="20">
                        <div class="grid-content bg-purple">
                          <el-form-item>
                            {{
                              "第" + (index+1) + "题：" + item.questionsList.replace(/\n/g,'')
                            }}
                            <span class="topictype">[简答题]</span>
                          </el-form-item>
                          <el-form-item label="">
                            <vxe-table
                              :data="item.options"
                              round
                              border
                              class="mytable-scrollbar"
                              style="width: 100%"
                              ref="multipleTable"
                              empty-text="没有更多数据了！"
                              resizable
                              stripe
                            >
                              <template
                                v-for="(item, key) in Data2List"
                                :key="key"
                              >
                                <vxe-table-column
                                  v-if="item.isShow && item.prop=='ratio'"
                                  :field="item.prop"
                                  :title="item.label"
                                  :width="item.width"
                                  align="center"
                                  :class-name="JSON.stringify(item)"
                                  :formatter="formatterData"
                                >
                                  <template #default="{ row, column }">
                                    <el-progress :percentage="row[column.property]" :color="customColorMethod"></el-progress>
                                  </template>
                                </vxe-table-column>
                                <vxe-table-column
                                  v-if="item.isShow && item.prop!='ratio'"
                                  :field="item.prop"
                                  :title="item.label"
                                  :width="item.width"
                                  align="center"
                                  :class-name="JSON.stringify(item)"
                                  :formatter="formatterData"
                                />
                              </template>
                            </vxe-table>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>

                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { GgetExamResultDetail } from "@api/Exam/ApiExamDataCenter";
import XEUtils from "xe-utils";
import { downloadPDF } from "@/util/pdf.js"

export default {
  name: "ExamReportDetail",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    parentcode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      DataList: [],
      Data1List: [
        {
          prop: "optionsList",
          label: "选项",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "isTrue",
          label: "是否正确",
          width: "150",
          format: "isTrue",
          order: false,
          isShow: true,
        },
        {
          prop: "optionPeople",
          label: "选择数量",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "ratio",
          label: "百分比",
          width: "300",
          format: "",
          order: false,
          isShow: true,
        },
      ],
      Data2List: [
        {
          prop: "optionsList",
          label: "选项",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "score",
          label: "得分情况",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "optionPeople",
          label: "选择数量",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "ratio",
          label: "百分比",
          width: "300",
          format: "",
          order: false,
          isShow: true,
        },
      ],
      title: "问卷标题"
    };
  },
  created() {},
  mounted() {},
  methods: {
     customColorMethod (percentage) {
      if (percentage < 30) {
        return '#909399'
      }
      if (percentage < 70) {
        return '#e6a23c'
      }
      return '#67c23a'
    },
    loadDataById(row) {
      var _this = this;
      this.title = row.name
      const loading = this.loading();
      GgetExamResultDetail(row.id).then((x) => {
        loading.close()
        _this.DataList = x;
      }).then(res=>{
        loading.close()
        console.log(res)
      });
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      let name = column.property;
      switch (name) {
        case "sumbitTime":
          cellValue = XEUtils.toDateString(cellValue, "yyyy-MM-dd HH:ss:mm");
          break;
        case "isTrue":
          cellValue =
            cellValue ? "是" :  "否";
          break;
      }
      return cellValue;
    },
    handleClose() {
      this.$emit("handleCancel");
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    // 下载报告，pdf格式
    downloadReport(){
      let filename = this.title;
      let loading = this.loading();
      downloadPDF(this.$refs.pdf,filename).then(result => {
        loading.close();
      })
    },
  },
};
</script>

<style lang="scss" scoped >
.switch-content {
  // height: 750px;
  // overflow-y: scroll;
}
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {

  .el-button {
    min-height: 0;
    // background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    // color: #ffffff;
    padding: 12px 20px;
    // border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  // min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
  padding-left: 20px;
  padding-top: 10px;
}
.topictype {
  color: #707070;
}
.title {
  font-size: 20px;
  margin-bottom: 5px;
  font-weight: 600;
}
</style>
